export class CuttingPaymentResponseDto {
  hmac: string;
  amount: number;
  order: number;
  nonce: string;
  timestamp: string;
  psbMerchant: string;
  psbTerminal: string;
  status: string;
  backendUrl: string;
  returnUrl: string;
  currancy: string;
  language: string;
  description: string;
  company: string;
  email: string;

  constructor(psbPaymentResponse?: CuttingPaymentResponseDto | any) {
    psbPaymentResponse = psbPaymentResponse || {};
    this.hmac = psbPaymentResponse.hmac || '';
    this.amount = psbPaymentResponse.amount || 0;
    this.order = psbPaymentResponse.order || 0;
    this.nonce = psbPaymentResponse.nonce || '';
    this.timestamp = psbPaymentResponse.timestamp || '';
    this.psbMerchant = psbPaymentResponse.psbMerchant || '';
    this.psbTerminal = psbPaymentResponse.psbTerminal || '';
    this.status = psbPaymentResponse.status || '';
    this.backendUrl = psbPaymentResponse.backendUrl || '';
    this.returnUrl = psbPaymentResponse.returnUrl || '';
    this.currancy = psbPaymentResponse.currancy || 'RUB';
    this.language = psbPaymentResponse.language || 'RU';
    this.description = psbPaymentResponse.description || '';
    this.company = psbPaymentResponse.company || '';
    this.email = psbPaymentResponse.email || '';
  }
}
